require('./mortgageRequestViewProcess.scss');

// @vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @utilities
const { getSplittedNumber } = require('utilities/currencyHelper');

// @components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const { text } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestViewProcess/initialValues');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');

const contentView = (info) => {
   const {type, amount, term, monthlyFee, tin, tae} = info;
   const formattedTerm = formatText('mortgageRequestViewProcess-labelYearsAntiquity', [term]);
   const formattedAmount = MortgageRequestCurrencyHelp({
       currency: amount,
       withDecimals: false
   });
   const taeVariable = getSplittedNumber(tae * 100);
   const formattedTae = `${taeVariable.whole}${taeVariable.decimalMark}${taeVariable.decimals}%`;
   const processViewTitle = formatText('mortgageRequestViewProcess-mortgageInfoTitle', [type]);

   const textValue = text();

   return (
       <div className="row">
           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <h3 className="mortgage-request-view-process__panel-right__title">{textValue.SECTION.MORTGAGE_INFO.TITLE}</h3>
           </div>
           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <span className="mortgage-request-view-process__panel-right__subtitle">{processViewTitle}</span>
           </div>

           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <span className="mortgage-request-view-process__panel-right__item">{textValue.SECTION.MORTGAGE_INFO.AMOUNT}</span>
               <span className="mortgage-request-view-process__panel-right__value">{formattedAmount}</span>
           </div>

           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <span className="mortgage-request-view-process__panel-right__item">{textValue.SECTION.MORTGAGE_INFO.TERM}</span>
               <span className="mortgage-request-view-process__panel-right__value">{formattedTerm}</span>
           </div>

           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <span className="mortgage-request-view-process__panel-right__item">{textValue.SECTION.MORTGAGE_INFO.MONTHLY_FEE}</span>
               <span className="mortgage-request-view-process__panel-right__value">{monthlyFee}</span>
           </div>

           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <span className="mortgage-request-view-process__panel-right__item">{textValue.SECTION.MORTGAGE_INFO.TIN}</span>
               <span className="mortgage-request-view-process__panel-right__value">{tin}</span>
           </div>

           <div className="col-xs-12 mortgage-request-view-process__panel-right-info-row">
               <span className="mortgage-request-view-process__panel-right__item">{textValue.SECTION.MORTGAGE_INFO.TAE}</span>
               <span className="mortgage-request-view-process__panel-right__item-description">{textValue.SECTION.MORTGAGE_INFO.TAE_INFO}</span>
               <span className="mortgage-request-view-process__panel-right__value">{formattedTae}</span>
           </div>
       </div>
   );
};

const mortgageInfo = (info) => {
   const { isFetching } = info;
   const content = isFetching ? <LoadingSection /> : contentView(info);

   return content;
};

module.exports = mortgageInfo;
